import React from 'react';
import P from 'prop-types';

/**
 * @component
 * @description Componente container base que fornece um wrapper responsivo para o conteúdo.
 * Pode ser usado como um container fixo ou fluido.
 *
 * @param {Object} props - Propriedades do componente
 * @param {React.ReactNode} props.children - Elementos filhos que serão renderizados dentro do container
 * @param {string} [props.addClassName] - Classes CSS adicionais para estilização personalizada
 * @param {string} [props.className] - Classes CSS para estilização (mantida para compatibilidade)
 * @param {boolean} [props.fluid=false] - Define se o container deve ser fluido (largura total) ou fixo
 * @param {React.Ref} ref - Referência React encaminhada para o elemento div
 *
 * @example
 * // Container fixo básico
 * <BContainer>
 *   <div>Conteúdo</div>
 * </BContainer>
 *
 * @example
 * // Container fluido com classe adicional
 * <BContainer fluid addClassName="my-custom-class">
 *   <div>Conteúdo em largura total</div>
 * </BContainer>
 */
const BContainer = React.forwardRef(function BContainer(props, ref) {
  const { addClassName, fluid, className } = props;
  return (
    <div
      ref={ref}
      className={`container${fluid ? '-fluid' : ''} ${addClassName ? addClassName : ''} ${
        className ? className : ''
      }`}
    >
      {props.children}
    </div>
  );
});

export default BContainer;
BContainer.propTypes = {
  children: P.node,
  addClassName: P.string,
  className: P.string,
  fluid: P.bool,
};
